import React from 'react'
import colors from 'globals/colors'
import { SButton } from './styles'

interface IProps {
  children: React.ReactNode,
  onClick?: () => void,
  disabled?: boolean,
  size?: 'small' | 'middle' | 'large',
  loading?: boolean,
  alternativestyle?: boolean,
  className?: string,
  ghost?: boolean,
  color?: string,
}

const Button = (props: IProps) => {
  const alternativestyle = props.alternativestyle || false

  return (
    <SButton
      className={props.className}
      type="primary"
      size={props.size || 'middle'}
      onClick={props.onClick}
      disabled={props.disabled || false}
      loading={props.loading || false}
      alternativestyle={alternativestyle ? 'true' : 'false'}
      ghost={props.ghost || false}
      color={props.color || colors.waterBlue}
    >
      {props.children}
    </SButton>
  )
}

export default Button
